import { useState, useEffect } from "react";
import "../../../css/carousel.css";

export default function ImageCarousel({ images, interval = 3000 }) {
  const [index, setIndex] = useState(0);

  const next = () => {
    setIndex((prev) => (prev + 1) % images.length);
  };

  const prev = () => {
    setIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  // Auto-slide (optional)
  useEffect(() => {
    const timer = setInterval(next, interval);
    return () => clearInterval(timer);
  }, [index]);

  return (
    <div className="carousel-container">
      <div
        className="carousel-slider"
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {images?.map((_image, i) => (
          <img
            key={i}
            src={window.$file + "BookCarousel/" + _image?.image}
            onClick={() => window.open(_image?.url, "_blank")}
            className="carousel-image"
          />
        ))}
      </div>

      <button className="carousel-btn left" onClick={prev}>
        <i className="fas fa-chevron-left"></i>
      </button>
      <button className="carousel-btn right" onClick={next}>
        <i className="fas fa-chevron-right"></i>
      </button>

      <div className="carousel-dots">
        {images.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === index ? "active" : ""}`}
            onClick={() => setIndex(i)}
          ></span>
        ))}
      </div>
    </div>
  );
}
